// extracted by mini-css-extract-plugin
export default {"bodyScroll":"Gr8f7r8my5kh3ACc"};